<template>
  <v-container fluid class="pa-0 my-4">
    <v-card>
      <v-card-title class="grey lighten-4 py-0">
        <span class="title primary--text">Employment</span>
        <v-spacer></v-spacer>
        <v-btn color="primary" icon flat @click.native="addWorkExperience" v-if="workExperienceList.length !== 0">
          <v-icon>add</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="pt-0">
        <div v-if="workExperienceList.length === 0" class="text-xs-center mt-2">
          <v-btn @click.native="addWorkExperience" round color="primary">Add Employment</v-btn>
        </div>
        <v-list v-else three-line>
          <template v-for="(workEntity , index) in workExperienceList">
            <v-list-tile avatar @click="">
              <v-list-tile-avatar>
                <v-icon>school</v-icon>
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title class="title-with-chips">
                  {{workEntity.companyName}}({{workEntity.designation}})
                  <v-chip small v-for="(work,index) in workEntity.keySkillsList"
                  color="secondary"
                  text-color="white" :key="index">{{work}}</v-chip>
                </v-list-tile-title>
                <v-list-tile-sub-title>
                  From: {{workEntity.startDate}} &nbsp; To: {{workEntity.endDate}}
                </v-list-tile-sub-title>
                <v-list-tile-sub-title>
                  {{workEntity.description}}
                </v-list-tile-sub-title>
              </v-list-tile-content>
              <v-list-tile-action>
                <v-btn color="primary" flat icon @click.native="editWorkExprience(workEntity)">
                  <v-icon>edit</v-icon>
                </v-btn>
              </v-list-tile-action>
            </v-list-tile>
            <v-divider v-if="index + 1 !== workExperienceList.length"></v-divider>
          </template>
        </v-list>
      </v-card-text>
    </v-card>
    <v-dialog v-model="dialogOpen" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click.native="dialogOpen = false">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>{{title}}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-menu v-model="deleteDialogOpen"
              :close-on-content-click="false" v-show="work.id !== null">
              <v-btn flat dark slot="activator">Delete</v-btn>
              <v-card>
                <v-card-title>
                  <span class="headline error--text">Delete Data</span>
                </v-card-title>
                <v-card-text>
                  Sure you want to delete this record?
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="error" outline round @click.native="deleteDialogOpen = false">No</v-btn>
                  <v-btn color="error" round @click.native="deleteWorkExperience" :loading="loading" :disabled="loading">Yes</v-btn>
                </v-card-actions>
              </v-card>
            </v-menu>
            <v-btn dark flat @click.native="saveWorkExprience" :loading="loading" :disabled="loading">Save</v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <v-form ref="workExperienceForm">
            <v-container grid-list-md>
              <v-subheader v-show="work.id === null" class="pa-0 primary--text">*Do not provide Freelance Training/Consulting Experience here</v-subheader>
              <v-layout wrap>
                <v-flex xs12 sm6>
                  <v-text-field name="designation" label="Designation" value="Input text" :counter="50" v-model="work.designation" :rules="rules.designation" box required></v-text-field>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field name="companyName" label="Company Name" value="Input text" :counter="50" v-model="work.companyName" :rules="rules.companyName" box required></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 class="pb-0">
                  <v-menu
                  ref="startDateMenu"
                  :close-on-content-click="false"
                  v-model="menu.startDate"
                  :return-value.sync="work.startDate"
                  lazy
                  transition="scale-transition"
                  full-width
                  max-width="290px"
                  min-width="290px"
                  >
                  <v-text-field
                  slot="activator"
                  v-model="work.startDate"
                  name="startDate"
                  label="From (YYYY-MM)"
                  value="Input text"
                  readonly
                  :rules="rules.isRequired"
                  box
                  required
                  ></v-text-field>
                  <v-date-picker
                  v-model="work.startDate"
                  type="month"
                  :max="currentMonth"
                  no-title
                  scrollable
                  @input="$refs.startDateMenu.save(work.startDate)"
                  >
                </v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex xs12 sm6 class="pb-0">
              <v-menu
              ref="endDateMenu"
              :close-on-content-click="false"
              v-model="menu.endDate"
              :return-value.sync="work.endDate"
              lazy
              transition="scale-transition"
              full-width
              max-width="290px"
              min-width="290px"
              >
              <v-text-field
              slot="activator"
              v-model="work.endDate"
              name="endDate"
              label="To (YYYY-MM)"
              value="Input text"
              readonly
              :rules="rules.isRequired"
              box
              required
              ></v-text-field>
              <v-date-picker
              v-model="work.endDate"
              type="month"
              :max="currentMonth"
              no-title
              scrollable
              @input="$refs.endDateMenu.save(work.endDate)"
              >
            </v-date-picker>
          </v-menu>
        </v-flex>
        <v-flex xs12 class="py-0">
          <small v-show="dateErrorStatus" class="error--text ml-2">
            End Date cannot be earlier than Start Date
          </small>
        </v-flex>
        <v-flex xs12 sm6>
          <v-text-field name="location" label="Location" value="Input text" :counter="64" v-model="work.location" :rules="rules.location" box required></v-text-field>
        </v-flex>
        <v-flex xs12 sm6>
          <v-switch
          :label="`Delivered trainings in this job? ${work.didTraining?'YES':'NO'}`"
          color="primary"
          v-model="work.didTraining"
          box
          ></v-switch>
        </v-flex>
        <v-flex xs12>
          <v-combobox
          box
          v-model="work.keySkillsList"
          label="Add key skills used in this job"
          chips
          multiple
          required
          clearable
          :rules="rules.keySkillsList"
          placeholder="After typing press enter to input more values"
          >
          <template slot="selection" slot-scope="data">
            <v-chip
            :selected="data.selected"
            close
            @input="remove(data.item)"
            color="secondary"
            text-color="white"
            small
            >
            <strong>{{ data.item }}</strong>
          </v-chip>
        </template>
      </v-combobox>
    </v-flex>
    <v-flex xs12>
      <v-textarea name="description" label="Description (optional)" rows="2" value="Input text" placeholder="project summary, role, responsibilities etc" :counter="2000" :rules="rules.description" v-model="work.description" box></v-textarea>
    </v-flex>
</v-layout>
</v-container>
</v-form>
</v-card-text>
</v-card>
</v-dialog>
</v-container>
</template>
<script>
/* globals Store */
import { mapState } from 'vuex'
export default {
  name: 'WorkCard',
  watch: {
    dialogOpen (value) {
      if (!value) {
        this.dateErrorStatus = false
      }
    }
  },
  data () {
    return {
      deleteDialogOpen: false,
      dateErrorStatus: false,
      rules: {
        isRequired: [
          (v) => !!v || 'Required'
        ],
        designation: [
          (v) => !!v || 'Designation is required',
          (v) => (v && v.length <= 50) || 'Designation must be less than 50 characters'
        ],
        companyName: [
          (v) => !!v || 'Company Name is required',
          (v) => (v && v.length <= 50) || 'Company Name must be less than 50 characters'
        ],
        description: [
          (v) => (!v || v.length <= 2000) || 'Description must be less than 2000 characters'
        ],
        location: [
          (v) => !!v || 'Location is required',
          (v) => (v && v.length <= 64) || 'Location must be less than 64 characters'
        ],
        keySkillsList: [
          (v) => (v && v.length !== 0) || 'Atleast one key skill is required'
        ]
      },
      dialogOpen: false,
      menu: {
        startDate: false,
        endDate: false
      }
    }
  },
  created () {
    Store.dispatch('profile/getWorkExperienceList')
  },
  computed: {
    ...mapState('profile', {
      workExperienceList: 'workExperienceList',
      work: 'work',
      loading: 'loading'
    }),
    title () {
      if (this.work.id === null) return 'Add Employment'
      else return 'Edit Work Experience'
    },
    currentMonth () {
      let today = new Date()
      let currentYear = today.getFullYear() + '-' + Number(today.getMonth() + 1)
      return currentYear
    }
  },
  methods: {
    remove (item) {
      this.work.keySkillsList.splice(this.work.keySkillsList.indexOf(item), 1)
      this.work.keySkillsList = [...this.work.keySkillsList]
    },
    cb () {
      this.$refs.workExperienceForm.reset()
      this.dialogOpen = false
      this.deleteDialogOpen = false
    },
    editWorkExprience (work) {
      Store.dispatch('profile/updateWorkExperienceForm', { ...work })
      this.dialogOpen = true
    },
    async saveWorkExprience () {
      var startDate = new Date(this.work.startDate)
      var endDate = new Date(this.work.endDate)
      if (startDate.getTime() > endDate.getTime()) {
        this.dateErrorStatus = true
        return false
      }
      if (this.$refs.workExperienceForm.validate()) {
        const work = { ...this.work }
        await Store.dispatch('profile/saveWorkExprience', { work, cb: this.cb })
        // this.cb()
        // this.dialogOpen = false
      }
    },
    addWorkExperience () {
      Store.dispatch('profile/updateWorkExperienceForm', null)
      // this.cb()
      this.$refs.workExperienceForm.reset()
      this.dialogOpen = true
    },
    async deleteWorkExperience () {
      await Store.dispatch('profile/deleteWorkExperience', {id: this.work.id, cb: this.cb})
    },
    cancelForm () {
      Store.dispatch('profile/updateWorkExperienceForm', null).then(this.cb)
    }
  }
}
</script>
<style>
.title-with-chips {
  height: auto !important;
}
</style>



// WEBPACK FOOTER //
// src/components/WorkCard.vue